export default {
  // list
  'contract.query.contractNo': '合同编号',
  'contract.query.contractNo.placeholder': '请输入合同编号',
  'contract.query.contractTitle': '合同标题',
  'contract.query.contractTitle.placeholder': '请输入合同标题',
  'contract.query.businessType': '业务类型',
  'contract.query.businessType.placeholder': '请输入业务类型',
  'contract.query.contractType': '合同类型',
  'contract.query.contractType.placeholder': '请输入合同类型',
  'contract.query.partyAName': '客户名称',
  'contract.query.partyAName.placeholder': '请输入客户名称',
  'contract.query.partyBName': '乙方名称',
  'contract.query.partyBName.placeholder': '请输入乙方名称',
  'contract.query.status': '状态',
  'contract.query.status.placeholder': '请选择状态',
  'contract.query.signDate': '生效日期',
  'contract.query.signDate.placeholder': '请输入生效日期',
  'contract.column.contractNo': '合同编号',
  'contract.column.contractTitle': '合同标题',
  'contract.column.businessType': '业务类型',
  'contract.column.contractType': '合同类型',
  'contract.column.partyAName': '客户名称',
  'contract.column.partyBName': '乙方名称',
  'contract.column.paymentPeriod': '账期',
  'contract.column.signDate': '生效日期',
  'contract.column.validityPeriod': '截止日期',
  'contract.column.voidStatus': '作废状态',
  'contract.column.createBy': '创建人',
  'contract.column.updateBy': '更新人',
  'contract.column.createTime': '创建时间',
  'contract.column.updateTime': '更新时间',
  'contract.column.dataSource': '数据来源',
  'contract.column.remark': '备注',
  'contract.column.status': '状态',
  'contract.operation.void': '作废',
  'contract.operation.enable': '启用',
  'contract.confirm.void': '确认要作废此合同吗？',
  'contract.confirm.enable': '确认要启用此合同吗？',
  'contract.void.success': '作废成功',
  'contract.enable.success': '启用成功',
  'contract.confirm.archive': '确认要归档此合同吗？',
  'contract.confirm.cancelArchive': '确认要回档此合同吗？',
  'contract.archive.success': '归档成功',
  'contract.cancelArchive.success': '取消回档成功',

  // edit
  'contract.edit.title': '编辑合同',
  'contract.add.title': '新增合同',
  'contract.edit.success': '编辑成功',
  'contract.add.success': '新增成功',
  'contract.form.contractNo.required': '合同编号不能为空',
  'contract.form.contractTitle.required': '合同标题不能为空',
  'contract.form.businessType.required': '业务类型不能为空',
  'contract.form.contractType.required': '合同类型不能为空',
  'contract.form.partyAId.required': '客户不能为空',
  'contract.form.partyAName.required': '客户名称不能为空',
  'contract.form.partyBId.required': '乙方不能为空',
  'contract.form.partyBName.required': '乙方名称不能为空',
  'contract.form.paymentPeriod.required': '账期不能为空',
  'contract.form.signDate.required': '生效日期不能为空',
  'contract.form.contractNo': '合同编号',
  'contract.form.contractNo.placeholder': '请输入合同编号',
  'contract.form.contractTitle': '合同标题',
  'contract.form.contractTitle.placeholder': '请输入合同标题',
  'contract.form.businessType': '业务类型',
  'contract.form.businessType.placeholder': '请输入业务类型',
  'contract.form.contractType': '合同类型',
  'contract.form.contractType.placeholder': '请输入合同类型',
  'contract.form.partyAId': '客户',
  'contract.form.partyAId.placeholder': '请输入客户',
  'contract.form.partyAName': '客户名称',
  'contract.form.partyAName.placeholder': '请输入客户名称',
  'contract.form.partyBId': '乙方',
  'contract.form.partyBId.placeholder': '请输入乙方',
  'contract.form.partyBName': '乙方名称',
  'contract.form.partyBName.placeholder': '请输入乙方名称',
  'contract.form.paymentPeriod': '账期',
  'contract.form.paymentPeriod.placeholder': '请输入账期',
  'contract.form.signDate': '生效日期',
  'contract.form.signDate.placeholder': '请输入生效日期',
  'contract.form.validityPeriod': '截止日期',
  'contract.form.validityPeriod.placeholder': '请输入截止日期',
  'contract.form.validityRemark': '备注',
  'contract.form.validityRemark.placeholder': '请输入备注',
}
